import { useEffect, useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FormikTouched } from "formik";

interface Props {
  value: any;
  name: any;
  placeholder: string;
  type: any;
  onChange: () => void;
  label: any;
  errors: any;
  touched?: FormikTouched<any>;
  handleSetAddressValuesByGoogleAPI: (value: any, name: string) => void;
}

function AddressAutoCompleteController(props: Props) {
  const [value, setValue] = useState<any>(null);
  const [address1, setAddress1] = useState<any>(null);
  const [addressAdded, seAddressAdded] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(
    "Address 1 is required"
  );
  useEffect(() => {
    if (value?.value?.terms.length > 1) {
      props.handleSetAddressValuesByGoogleAPI(value, props.name);
    }
  }, [value]);

  useEffect(() => {
    setAddress1(props.value);
  }, [props.value]);

  const handleAddressAdded = () => {
    seAddressAdded(!addressAdded);
  };

  function handleAddressAddedOnCLick() {
    if (addressAdded) {
      seAddressAdded(false);
    }
  }
  if (props.value) {
    props.errors[props.name] = undefined;
  }
  const handleOnBlur = () => {
    if (!address1 && props.name === "address1") {
      setIsError(true);
      setErrorMessage("Address 1 is required");
    }
  };

  useEffect(() => {
    if (address1) {
      setIsError(false);
    }
  }, [address1]);
  return (
    <div>
      {props.label !== null ? (
        <>
          <label htmlFor="">{props.label}</label>
        </>
      ) : null}
      <div
        className={
          isError || (props.touched?.[props.name] && props.errors?.[props.name])
            ? "label-inside-input-error address-search input-container-wrapper"
            : "label-inside-input address-search input-container-wrapper"
        }
        onBlur={handleAddressAdded}
        onClick={handleAddressAddedOnCLick}
      >
        {
          <div onBlur={handleOnBlur}>
            <FontAwesomeIcon icon={faSearch} className="fa-search" />
            <GooglePlacesAutocomplete
              selectProps={{
                value,
                onChange: setValue,
                placeholder: "Search address...",
                components: {
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                },
                className: "input-control",
              }}
            />
          </div>
        }
        <div className="error-line">
          {isError ||
          (props.touched?.[props.name] && props.errors?.[props.name]) ? (
            <span>{errorMessage}</span>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default AddressAutoCompleteController;
